import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-4" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control w-25",
  placeholder: "Enter Search Key !"
}, null, -1)
const _hoisted_6 = {
  type: "button",
  class: "btn btn-primary me-1 ms-1"
}
const _hoisted_7 = {
  type: "button",
  class: "btn btn-default border"
}
const _hoisted_8 = { class: "card mb-4 d-none d-md-block" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_14 = {
  key: 0,
  class: "table card-table"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_16 = { class: "table-border-bottom-0" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-0" }, "Please Register Customer", -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "mobile-view d-block d-md-none" }
const _hoisted_24 = {
  key: 0,
  class: "card"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "spinner-border text-primary",
      role: "status"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
    ])
  ])
], -1)
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode()
const _hoisted_31 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Email: ")
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createTextVNode()
const _hoisted_36 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_38 = ["onClick"]
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_40 = { key: 2 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-0 text-wrap" }, "Please Register Customer")
  ])
], -1)
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = {
  key: 0,
  class: "card"
}
const _hoisted_44 = { class: "card-body d-flex justify-content-around flex-wrap" }
const _hoisted_45 = {
  "aria-label": "Page navigation ",
  class: "flex-wrap"
}
const _hoisted_46 = { class: "pagination flex-wrap" }
const _hoisted_47 = ["onClick", "innerHTML"]
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-12" }
const _hoisted_50 = { class: "input-group" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", {
  class: "input-group-text",
  for: "inputGroupSelect01"
}, "Size", -1)
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<option value=\"10\">10</option><option value=\"20\">20</option><option value=\"30\">30</option><option value=\"40\">40</option><option value=\"50\">50</option><option value=\"100\">100</option>", 6)
const _hoisted_58 = [
  _hoisted_52
]
const _hoisted_59 = {
  class: "modal fade",
  id: "modalCenter",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_60 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_61 = { class: "modal-content" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title text-center",
    id: "modalCenterTitle"
  }, "Delete Confirmation !"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1)
const _hoisted_63 = { class: "modal-body text-center" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("i", { class: "bx bx-bell bx-lg text-danger mb-3 d-inline-block" }, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", null, "Are You Sure to Delete ?", -1)
const _hoisted_66 = { class: "modal-footer text-center justify-content-center" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, " Close ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", _hoisted_6, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'magnifying-glass'] })
            ]),
            _createElementVNode("button", _hoisted_7, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'broom'] })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_ctx.fettchDataArray.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("tbody", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: dataItem.id
                        }, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.name), 1),
                          _createElementVNode("td", null, _toDisplayString(dataItem.phone), 1),
                          _createElementVNode("td", null, [
                            (dataItem.email)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(dataItem.email), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_18, "--"))
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_router_link, {
                              class: "me-2 btn btn-sm btn-warning",
                              to: { name: 'customer-form', params: { id: dataItem.id.toString() } }
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pen-to-square'] })
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "me-2 btn btn-sm btn-danger",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modalCenter",
                              onClick: ($event: any) => (_ctx.fetchItem(dataItem))
                            }, [
                              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash-can'] })
                            ], 8, _hoisted_19)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
            ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
        : _createCommentVNode("", true),
      (_ctx.fettchDataArray.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fettchDataArray, (dataItem) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card mb-4",
                key: dataItem.id
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("strong", null, " Name: " + _toDisplayString(dataItem.name), 1),
                  _hoisted_29,
                  _createElementVNode("small", null, "Phone: " + _toDisplayString(dataItem.phone), 1),
                  _hoisted_30,
                  _hoisted_31,
                  _createElementVNode("small", null, [
                    _hoisted_32,
                    (dataItem.email)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(dataItem.email), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_34, "--"))
                  ]),
                  _hoisted_35,
                  _hoisted_36,
                  _createVNode(_component_router_link, {
                    class: "me-2 btn btn-sm btn-warning",
                    to: { name: 'customer-form', params: { id: dataItem.id.toString() } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, { icon: ['fas', 'pen-to-square'] }),
                      _hoisted_37
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "me-2 mt-2 btn btn-sm btn-danger",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modalCenter",
                    onClick: ($event: any) => (_ctx.fetchItem(dataItem))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash-can'] }),
                    _hoisted_39
                  ], 8, _hoisted_38)
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_40, _hoisted_42))
    ]),
    (_ctx.fettchDataArray.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("nav", _hoisted_45, [
              _createElementVNode("ul", _hoisted_46, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginationData.links, (page, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: _normalizeClass(["page-item myPagination m-1", { active: page.active }])
                  }, [
                    _createElementVNode("button", {
                      class: "page-link",
                      onClick: ($event: any) => (_ctx.goToPage(Number(page.label))),
                      innerHTML: page.label
                    }, null, 8, _hoisted_47)
                  ], 2))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    id: "inputGroupSelect01",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchData && _ctx.fetchData(...args)))
                  }, _hoisted_58, 544), [
                    [_vModelSelect, _ctx.pageSize]
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_59, [
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _hoisted_62,
          _createElementVNode("div", _hoisted_63, [
            _hoisted_64,
            _hoisted_65,
            _createElementVNode("p", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.deletevalue.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("button", {
              "data-bs-dismiss": "modal",
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteItem(_ctx.deletevalue.id)))
            }, "Confirm")
          ])
        ])
      ])
    ])
  ]))
}